import { render } from "./ResetPasswordFirstPage.vue?vue&type=template&id=523a8c36&ts=true"
import script from "./ResetPasswordFirstPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordFirstPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__